
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"disabled-highlight",attrs:{"d":"M22.774 16.387H1.227C.55 16.387 0 15.837 0 15.16V3.574C0 2.9.55 2.35 1.226 2.35h21.548C23.45 2.35 24 2.9 24 3.574v11.587c0 .676-.55 1.226-1.226 1.226zM1.227 3.339a.236.236 0 00-.236.235v11.587c0 .13.106.236.236.236h21.548c.13 0 .236-.106.236-.236V3.574a.236.236 0 00-.236-.235H1.227z","fill":"#00003C"}}),_c('path',{staticClass:"active-highlight disabled-highlight",attrs:{"d":"M9.438 13.13a.504.504 0 01-.268-.44V6.047a.495.495 0 01.782-.403l4.67 3.321a.495.495 0 010 .807l-4.67 3.321a.453.453 0 01-.514.037zm.722-6.124v4.724l3.322-2.362-3.322-2.362z","fill":"#00003C"}}),_c('path',{staticClass:"disabled-highlight",attrs:{"d":"M23.505 19.196h-9.46a1.962 1.962 0 00-1.895-1.465c-.91 0-1.675.623-1.895 1.465H.495a.495.495 0 000 .99h9.76c.22.84.986 1.464 1.895 1.464.91 0 1.676-.623 1.896-1.465h9.46a.495.495 0 000-.99zM12.15 20.66a.97.97 0 010-1.939.97.97 0 010 1.939z","fill":"#00003C"}})])
          )
        }
      }
    